// The one thing the listening dock cannot do for itself: put you back in your
// chair.
//
// Sitting needs two things the dock has no access to — the resolved pose of your
// seat (which lives in the 3D layer, where the room's furniture is) and the
// camera you are sitting down FROM (so standing up returns you to where you were
// rather than to the middle of the room). The dock is DOM, mounted outside the
// Canvas, and can reach neither.
//
// So the 3D layer publishes the action and the dock calls it. A plain module
// object like interiorFloor and floorBridge, for the same reason: it holds a
// closure over live scene state and nothing should re-render because a chair
// became available.
export const seatBridge = { sit: null };

export function setSeatSitter(fn) { seatBridge.sit = fn || null; }
